export const devLog = async (log?: any, ...optionalParams: any[]) => {
  const env = process.env.NODE_ENV;
  if(env == 'development') console.log(log, ...optionalParams);
}
export const devError = async (log?: any, ...optionalParams: any[]) => {
  const env = process.env.NODE_ENV;
  if(env == 'development') console.log(log, ...optionalParams);
}